/** @format */

import { SvgIcon } from '@mui/material';

function Symbol(props) {
  return (
    <svg
      {...props}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 544 544"
    >
      {/* 3D */}
      <path
        fill="blue"
        opacity="1.000000"
        stroke="none"
        d="
M363.829102,376.860840 
	C354.480774,384.242065 343.974640,388.611572 332.911621,390.992554 
	C322.537903,393.225189 311.803650,393.265045 301.164276,392.302063 
	C284.901978,390.830139 270.160828,385.012543 256.455994,376.383942 
	C250.581085,372.685059 250.343430,370.461182 255.260071,365.509186 
	C260.574036,360.157043 264.714264,353.889587 269.373718,348.025940 
	C273.378510,342.986206 275.392670,342.830414 279.693115,347.416046 
	C283.687988,351.675781 289.175018,352.953949 294.296417,354.458405 
	C310.362549,359.177979 326.190643,358.129089 340.343781,348.725403 
	C352.937073,340.358063 359.698486,328.418518 358.292419,312.663544 
	C357.716949,306.215424 357.916748,299.754364 354.795197,293.698792 
	C347.217773,278.999207 334.935425,271.936798 318.811584,272.069336 
	C312.031830,272.125031 307.827057,269.972473 303.807159,264.597504 
	C296.425964,254.728210 289.022675,244.873611 281.839844,234.858932 
	C277.680298,229.059509 277.839905,226.819458 283.634399,223.055801 
	C294.002380,216.321533 303.425476,208.370224 313.204590,200.881729 
	C315.706909,198.965546 320.571320,197.463577 319.613342,194.191116 
	C318.453735,190.229752 313.521057,192.066757 310.251038,192.010529 
	C297.923279,191.798630 285.588348,192.023270 273.259399,191.848709 
	C269.372437,191.793686 265.693085,192.976730 261.864838,193.048279 
	C258.495789,193.111252 256.626221,191.984100 256.811859,188.078674 
	C257.238617,179.099533 258.148895,170.135437 257.794800,161.122086 
	C257.639771,157.175598 260.157684,155.974533 263.625977,155.969727 
	C273.623322,155.955872 283.620636,155.918793 293.617981,155.917114 
	C332.442566,155.910599 371.267212,155.963669 410.091675,155.895325 
	C432.646851,155.855621 454.411469,159.707718 475.371765,168.179138 
	C480.449707,170.231476 483.911591,174.353348 488.433990,177.149811 
	C502.272705,185.707077 512.203003,198.352371 519.800049,212.369888 
	C528.264832,227.988678 533.604797,244.714828 533.564941,262.990540 
	C533.542175,273.444122 534.076477,283.944977 533.070190,294.326660 
	C530.377075,322.110718 518.735596,345.471771 497.296692,363.715271 
	C481.074463,377.519684 462.551727,386.261230 441.438293,389.327820 
	C435.352631,390.211731 429.231293,390.866821 423.114319,391.513336 
	C416.200317,392.244049 414.826141,390.839081 414.922302,384.009216 
	C415.025452,376.680145 414.906097,369.348175 414.907623,362.017456 
	C414.908325,358.710754 415.480469,356.315033 419.864441,356.303955 
	C440.134949,356.252747 458.034119,349.553040 473.134705,335.995239 
	C489.224884,321.548889 496.835815,303.242523 498.066162,281.720154 
	C498.929626,266.615112 497.419983,251.930893 491.038971,238.367401 
	C480.668091,216.323029 463.866577,201.120667 439.726135,195.225891 
	C424.567871,191.524445 408.973907,192.203293 393.531586,191.534271 
	C388.981018,191.337128 385.090027,193.702499 381.624146,196.220322 
	C368.725739,205.590500 356.137543,215.390549 343.165466,224.654755 
	C338.971985,227.649612 335.497009,231.506317 331.024567,234.097870 
	C329.929321,234.732529 329.266083,235.652710 329.561249,236.984665 
	C329.810577,238.109955 330.710693,238.537064 331.726227,238.780350 
	C332.050079,238.857910 332.377045,238.970718 332.704529,238.977859 
	C345.905579,239.265457 356.907471,245.612762 367.623413,252.228287 
	C376.192719,257.518555 382.328308,265.361938 387.586914,273.965637 
	C395.886230,287.544312 396.601532,302.455872 396.449219,317.739746 
	C396.338074,328.892792 394.187408,339.496124 388.921265,349.192108 
	C382.913879,360.252930 374.825317,369.707916 363.829102,376.860840 
z"
      />
      {/* M */}
      <path
        fill="orange"
        opacity="1.000000"
        stroke="none"
        d="
M229.335709,187.001434 
	C229.376419,253.641876 229.390793,319.782745 229.515533,385.923401 
	C229.522461,389.597076 228.385315,391.299561 224.668213,390.839355 
	C216.361465,389.810974 208.029175,390.350677 199.714157,390.538818 
	C196.089066,390.620880 195.042068,389.047272 195.042816,385.776642 
	C195.050766,350.639984 195.040741,315.503265 194.963348,280.366699 
	C194.928513,264.544250 194.768494,248.721634 194.561157,232.900452 
	C194.534943,230.900253 195.251221,228.158966 192.358353,227.434875 
	C189.857071,226.808807 189.060822,229.208496 187.919174,230.759262 
	C175.787827,247.238007 165.550491,264.983002 153.887329,281.761871 
	C148.680573,289.252441 142.790726,296.296387 137.639008,303.859558 
	C135.203995,307.434357 132.948471,306.963379 130.735931,303.670624 
	C114.963257,280.197174 97.841507,257.655273 82.557152,233.840927 
	C80.272583,230.281387 77.327835,227.145569 74.611305,223.716293 
	C70.817894,226.178787 71.749207,229.842239 71.713226,232.930588 
	C71.608490,241.920486 71.998390,250.915192 71.957024,259.906921 
	C71.822189,289.219177 71.344368,318.532135 71.495842,347.842285 
	C71.558632,359.992859 71.838699,372.135651 71.569290,384.291809 
	C71.469315,388.802673 69.846054,390.240295 65.367027,390.515259 
	C58.932926,390.910217 55.591061,389.190582 52.745529,382.618378 
	C44.555603,363.702454 38.426495,344.156891 34.523754,324.094727 
	C28.804193,294.693176 27.792042,265.037170 33.394993,235.302856 
	C38.134827,210.149017 45.313953,185.824417 55.694016,162.442123 
	C59.150223,154.656631 71.141045,153.007950 76.125885,159.863922 
	C88.444542,176.806549 100.473289,193.959656 112.686424,210.979462 
	C118.406654,218.950974 124.192810,226.878937 130.122955,234.694702 
	C133.801147,239.542435 136.764435,239.714600 140.464066,234.827835 
	C148.198914,224.611038 155.508453,214.073471 163.080582,203.732010 
	C172.999451,190.185501 183.290466,176.900055 192.844147,163.102615 
	C197.337524,156.613297 202.822205,154.937042 210.000519,156.166092 
	C214.783661,156.985031 219.621643,156.985550 224.449966,156.691956 
	C229.207367,156.402664 231.275772,158.212631 230.404449,163.082199 
	C229.009995,170.875275 229.466019,178.687912 229.335709,187.001434 
z"
      />
      {/* upper sphere */}
      <path
        fill="silver"
        opacity="1.000000"
        stroke="none"
        d="
M88.790031,111.815094 
	C98.394066,100.462563 108.467255,90.039619 119.639145,80.784927 
	C137.927185,65.635277 157.889893,53.069359 179.662491,43.509624 
	C187.125214,40.232952 194.649384,37.007637 202.365311,34.412422 
	C227.945068,25.808790 254.301788,21.172533 281.283417,21.344906 
	C304.964172,21.496187 328.095123,25.212084 351.051239,31.751863 
	C364.909424,35.699802 377.430908,41.963299 390.535309,47.290787 
	C399.408691,50.898197 407.536682,55.681068 415.542236,60.550331 
	C424.135315,65.776970 431.585236,72.850197 439.742462,78.833427 
	C455.217773,90.184380 467.716248,104.533455 480.357452,118.734657 
	C485.230957,124.209549 484.320648,127.741661 478.024048,131.410065 
	C472.583435,134.579758 466.830200,137.191757 462.036469,141.515060 
	C458.035431,145.123428 453.717896,144.413651 450.069763,139.581238 
	C438.839844,124.705803 425.561523,111.966850 410.721344,100.773247 
	C388.941711,84.345421 364.905029,72.353806 338.729065,64.851730 
	C322.343109,60.155495 305.317474,59.324406 288.415497,57.926537 
	C277.874969,57.054790 267.543549,59.285683 257.137207,59.759644 
	C241.942261,60.451694 227.412125,63.891758 213.327774,68.696228 
	C197.801529,73.992554 182.716644,80.570778 168.641205,89.427887 
	C154.332428,98.431808 141.286072,108.851433 129.034485,120.382622 
	C123.078712,125.988182 118.048767,132.415543 112.998558,138.808517 
	C108.445587,144.572052 106.106697,145.161514 99.952377,141.395721 
	C93.986732,137.745361 88.136307,133.906281 82.159836,130.274246 
	C78.913010,128.301071 78.510117,125.964905 80.339035,122.758247 
	C82.594139,118.804375 85.789543,115.618301 88.790031,111.815094 
z"
      />
      {/* Lower Sphere */}
      <path
        fill="silver"
        opacity="1.000000"
        stroke="none"
        d="
M479.423645,433.432556 
	C466.831177,450.804626 452.084991,465.617340 435.280762,478.276367 
	C414.166656,494.182068 391.181427,506.717163 366.214844,515.648010 
	C347.325409,522.404968 328.018250,527.162537 308.115967,529.565796 
	C290.185028,531.730896 272.305786,531.558105 254.317291,529.633728 
	C232.802231,527.332031 212.106262,521.968750 192.060837,514.200928 
	C164.687134,503.593262 139.696198,489.068146 117.673569,469.250122 
	C105.372055,458.180115 94.204506,446.207489 83.298141,433.884247 
	C82.526566,433.012421 81.757355,432.129059 81.081207,431.183685 
	C76.197021,424.354645 76.639664,422.608093 83.822723,418.634552 
	C89.214592,415.651886 94.489326,412.458008 99.830017,409.382172 
	C104.854004,406.488800 108.279022,406.958740 111.450714,411.559235 
	C117.153305,419.830688 123.694969,427.528046 130.708389,434.519562 
	C137.727554,441.516815 145.435959,447.994080 153.481628,454.034119 
	C162.178894,460.563385 170.983673,466.655396 180.999985,470.883881 
	C199.712021,478.783417 217.674530,488.895294 238.077179,492.009583 
	C255.966995,494.740234 273.845184,496.278046 292.170288,495.189056 
	C309.109406,494.182465 325.728638,492.464661 341.776550,487.337250 
	C374.211731,476.973938 403.424866,460.753143 428.769836,437.751007 
	C437.354706,429.959686 444.457947,420.993408 451.266022,411.741760 
	C454.907043,406.793854 458.192230,405.215485 462.831696,409.072479 
	C468.828125,414.057617 475.988617,416.827179 482.300629,421.135315 
	C486.402222,423.934723 485.862457,425.998535 483.200714,428.966492 
	C481.978973,430.328766 480.824768,431.751617 479.423645,433.432556 
z"
      />
    </svg>
  );
}

export default Symbol;
